import React from "react";
import {
  StoplossType,
  StoplossTypeName,
  Frequencies,
  FrequencyValues,
  BotType,
  BotTypeName,
  TakeProfitTypeName,
  TakeProfitType
} from "../../../Const";
import {useSelector } from "react-redux";
import { Row, Table } from "react-bootstrap";

const AdvanceBotSetting = (props) => {
  const { bot,t } = props;
  const isExitBot = bot.type==BotType.exit;
  const theme = useSelector((state) => state.settings.selected_theme);
  const tsls = bot.tsls || [];
  let stoploss = (bot.stop_loss || 0).toFixed(2) + "%";
  if (tsls.length) {
    stoploss =
      tsls[0].sl_type === StoplossType.fixedTsl
        ? StoplossTypeName.fixedTsl
        : StoplossTypeName.variableTsl;
  }
  const tps = bot.tps || [];
  let takeProfit = (bot.profit || 0).toFixed(2) + "%";
  if (tps.length) {
    takeProfit =
    tps[0].tp_type === TakeProfitType.fixedTP
        ? TakeProfitTypeName.fixedTP
        : TakeProfitTypeName.variableTP;
  }
  const exchangePair = bot.exchange_pair || {};
  const exchange = exchangePair.exchange || {};
  const pair = exchangePair.pair || {};
  const indicators = bot.bot_indicators || [];
  const entryIndicators =
    indicators &&
    indicators
      .filter((item) => item.type == "entry")
      .map((item) => item.name)
      .join(", ");
  const exitIndicators =
    indicators &&
    indicators
      .filter((item) => item.type == "exit")
      .map((item) => item.name)
      .join(", ");
  return (
    <Row>
      <Table responsive className={`theme-bg ${theme}`}>
        <thead>
          <tr>
            <th>{t("exchange")}</th>
            <th>{t("pair")}</th>
            <th>{t("bot-type")}</th>
            <th>{t("strategy")}</th>
            <th>{t("frequency")}</th>
            {!isExitBot && <th>{t("entry-indicators")}</th>}
            <th>{t("exit-indicators")}</th>
            <th>{t("tp")}</th>
            <th>{t("stoploss")}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div>
                <img
                  src={exchange.image}
                  width={20}
                  height={20}
                  style={{ marginRight: 10 }}
                />
                <span style={{ fontWeight: "bold" }}>{exchange.name}</span>
              </div>
            </td>
            <td>{pair && `${pair.from}/${pair.to}`}</td>
            <td>{bot && BotTypeName[bot.type]}</td>
            <td>{bot && bot.strategy}</td>
            <td>
              {bot && Frequencies[FrequencyValues.indexOf(bot.frequency)]}
            </td>
            {!isExitBot && <td>{entryIndicators}</td>}
            <td>{exitIndicators}</td>
            <td>{bot && takeProfit} {bot.type == BotType.price?'':''}</td>
            <td>{stoploss}</td>
          </tr>
        </tbody>
      </Table>
    </Row>
  );
};

export default AdvanceBotSetting;
